import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UsersService} from "../../admin/users/users.service";
import {Router} from "@angular/router";
import {error} from "protractor";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private userService: UsersService, private router: Router) { }
  
  IsAdminLogin():Promise<boolean>{
    return new Promise((resolve, reject) => {
      if(!this.IsLoggedIn()){
        this.router.navigate(['/landing'],{ queryParams: { } });
        resolve(false)
      }else{
        this.userService.getUserDetails().subscribe(res=>{
          if(res['is_superuser']){
            resolve(res['is_superuser'])
          }else{
            this.router.navigate(['/landing'],{ queryParams: { } }).then(()=>{
              window.location.reload();
            });
          }
        },error=>{
          this.router.navigate(['/landing'],{ queryParams: { } }).then(()=>{
            window.location.reload();
          });
        })
      }
    })
  }

  IsLoggedIn(){
    return !!localStorage.getItem('token')
  }
}
